import useForm from "../hooks/useForm";
import useAuth from "../hooks/useAuth";
import uniminutoLogo from "../assets/uniminuto/logo-uniminuto-login.png";
import { useEffect } from "react";

const Login = ({ setIsAuthenticated }) => {
    const { loading, login, ToastContainer } = useAuth(setIsAuthenticated);
    const { handleInputChange, formulario } = useForm({
        email: "",
        pass: ""
    });

    const handleLogin = () => {
        if (formulario) {
            if (
                formulario.hasOwnProperty("email") &&
                formulario.hasOwnProperty("pass")
            ) {
                const { email, pass } = formulario;
                login(email, btoa(pass));
            }
        }
    };

    useEffect(() => {
        const handleKeyUp = ({ key }) => {
            if (key === "Enter") {
                handleLogin();
            }
        };

        // Agregar el listener al desmontar el componente
        const body = document.querySelector("body");
        body.addEventListener("keyup", handleKeyUp);

        return () => {
            body.removeEventListener("keyup", handleKeyUp);
        };
    }, [handleLogin]);

    return (
        <section className="vh-100" style={{ backgroundColor: '#162644' }} >
            <ToastContainer />
            <div className="container py-2 h-100">
                <div className="row d-flex justify-content-center align-items-center h-100">
                    <div className="col-xl-10">
                        <div className="card" style={{ borderRadius: '1rem' }}>
                            <div className="row g-0">
                                <div className="col-md-6 col-lg-5 d-none d-md-block">
                                    <img
                                        src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/img1.webp"
                                        alt="login form"
                                        className="img-fluid"
                                        style={{ borderRadius: '1rem 0 0 1rem' }}
                                    />
                                </div>
                                <div className="col-md-6 col-lg-7 d-flex align-items-center">
                                    <div className="card-body p-2 p-lg-3 text-black">
                                        <form>
                                            <div className="d-flex align-items-center mb-3 pb-1">
                                                <img src={uniminutoLogo} />
                                            </div>
                                            <h5 className="fw-normal pb-2">Ingresa a tu cuenta</h5>
                                            <div className="form-outline">
                                                <input
                                                    id="formEmail"
                                                    name="email"
                                                    className="form-control form-control-lg"
                                                    onChange={(e) => { handleInputChange(e, true) }}
                                                />
                                                <small className="form-label" htmlFor="formEmail">Correo Institucional</small>
                                            </div>
                                            <div className="form-outline">
                                                <input
                                                    type="password"
                                                    id="formPassword"
                                                    name="pass"
                                                    className="form-control form-control-lg"
                                                    onChange={(e) => { handleInputChange(e, true) }}
                                                />
                                                <small className="form-label" htmlFor="formPassword">Contraseña</small>
                                            </div>
                                            <div className="pt-2">
                                                <button
                                                    className="btn btn-dark btn-lg btn-block d-flex aling-items-center"
                                                    type="button"
                                                    onClick={handleLogin}
                                                    disabled={loading}
                                                >
                                                    Login
                                                    {
                                                        loading && (
                                                            <div className="spinner-border text-secondary ms-auto" role="status">
                                                                <span className="visually-hidden"></span>
                                                            </div>
                                                        )
                                                    }
                                                </button>
                                            </div>
                                            <a className="small text-muted" href="#!">¿Olvidaste tu contraseña?</a>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}


export default Login;